import { Box, Flex, Text } from '@chakra-ui/react';
import { ChatMessageStatus } from 'enums/modules/chat/chatMessageStatus';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { BsCheck, BsCheckAll } from 'react-icons/bs';
import { MdAccessTime, MdOutlineErrorOutline } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { formatMessageTime } from 'utils/formatMessageTime';

interface Props {
  createdAt: Date;
  isSelfMessage: boolean;
  status: ChatMessageStatus;
}

const statusIcon = {
  [ChatMessageStatus.Read]: <BsCheckAll color="gray.500" />,
  [ChatMessageStatus.Sent]: <BsCheck color="gray.500" />,
  [ChatMessageStatus.Failed]: <MdOutlineErrorOutline color="red" />,
  [ChatMessageStatus.Sending]: <MdAccessTime color="gray.500" />,
};

const ChatMessageStatusRow: FC<Props> = ({
  createdAt,
  isSelfMessage,
  status,
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      alignItems="center"
      justifyContent={isSelfMessage ? 'flex-end' : 'flex-start'}
    >
      <Text fontSize={FontSize.sm}>{formatMessageTime(createdAt, t)}</Text>
      {isSelfMessage && <Box ml={1}>{statusIcon[status]}</Box>}
    </Flex>
  );
};

export default ChatMessageStatusRow;
